export default __webpack_public_path__ + "static/media/open-modal-icon-disabled.d46199cf.svg";